import gql from 'graphql-tag';

const query = gql`
    query UserData {
        me {
            id
            name
            sex
            passwordIsSet
            hasExternalProviderSetUp
        }
    }
`;

export default query;
